export default __webpack_public_path__ + "media/Veggies-Fruit.380f0901.png";